<!--
 * @Author: mcdowell
 * @Date: 2021-09-17 15:05:41
 * @LastEditors: mcdowell
 * @LastEditTime: 2022-03-24 18:19:54
-->
<template>
  <div class="footer-contact">
    <a
      v-for="(item, index) in contactList"
      :key="index"
      class="icon-link"
      target="_bank"
      rel="noopener noreferrer"
      :href="item.href"
      :title="item.name"
    >
      <img :src="item.icon" :alt="item.name" width="100%" height="auto" />
    </a>
  </div>
</template>
<script>
import { contactList } from './data';

export default {
  name: 'social-contact',
  data() {
    return {
      contactList
    };
  }
};
</script>
<style lang="less" scoped>
.footer-contact {
  padding-top: 12px;
  display: flex;
  justify-content: center;
  a.icon-link {
    width: 32px;
    height: 32px;
    margin-right: 25px;
    margin-left: 25px;
  }
  img {
    vertical-align: top;
  }
}
@media (max-width:750px) {
  .footer-contact {
  padding-top: 0.24rem;
  a.icon-link {
    width: 0.64rem;
    height: 0.64rem;
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
}
}
</style>
